import i18next from "src/i18n/config";

import { Group } from "@dashboard/devices/types";
import { Theme } from "@mui/material";
import TimeService from "@services/timeService/timeService";

export const chartHeight = 240;

/**
 * Minimum value to avoid log(0)
 */
export const LogZeroBuffer = 0.5;

export const TimeRangeOptions = [
    { label: i18next.t("pages:overviewPage.cards.eventChart.last7Days"), value: 7 },
    { label: i18next.t("pages:overviewPage.cards.eventChart.last14Days"), value: 14 },
    { label: i18next.t("pages:overviewPage.cards.eventChart.last30Days"), value: 30 },
    { label: i18next.t("pages:overviewPage.cards.eventChart.last60Days"), value: 60 },
];

// When user selects N days, we want data from (N-1) days ago to today
// This ensures the chart shows exactly N days including today
export const daysOffset = 1;

const getFromDate = (dayRange: number) => {
    const fromDate = new Date();
    fromDate.setDate(fromDate.getDate() - (dayRange - daysOffset));
    return TimeService.getLocalDate(fromDate.getTime(), "MILLIS", "date");
};

/**
 * Activity report request arguments other than the workspace. The startup prefetch and the chart must build them the
 * same way, or the chart misses the prefetched cache entry and requests the report a second time.
 */
export function getActivityReportScope(dayRange: number, groupIds: number[], allGroups: Group[]) {
    return {
        fromDate: getFromDate(dayRange),
        groupIds: groupIds.length > 0 ? groupIds : allGroups.map((group) => group.id),
        allWorkspaceGroupsLength: allGroups.length,
    };
}

export function getEventColors(theme: Theme) {
    return { notice: theme.palette.emteria.success, warning: theme.palette.emteria.warning };
}

type ChartEventLevel = "notice" | "warning";

export type ClickedPoint = {
    level: ChartEventLevel;
    epochMs: number;
    count: number;
    hasOverlappingEvents: boolean;
};
